/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitChallengeResponseBody
 */
export interface SubmitChallengeResponseBody {
    /**
     * Whether the user opted in to receive newsletter emails
     * @type {boolean}
     * @memberof SubmitChallengeResponseBody
     */
    newsletter?: boolean;
    /**
     * The user's zip code (required if newsletter opt-in)
     * @type {string}
     * @memberof SubmitChallengeResponseBody
     */
    zipCode?: string;
    /**
     * First name captured at marketing opt-in. Max 100 chars.
     * @type {string}
     * @memberof SubmitChallengeResponseBody
     */
    firstName?: string;
    /**
     * Last name captured at marketing opt-in. Max 100 chars.
     * @type {string}
     * @memberof SubmitChallengeResponseBody
     */
    lastName?: string;
    /**
     * Optional milestone ID for DATA_COLLECTION milestones - will create quest progression
     * @type {string}
     * @memberof SubmitChallengeResponseBody
     */
    milestoneId?: string;
}

/**
 * Check if a given object implements the SubmitChallengeResponseBody interface.
 */
export function instanceOfSubmitChallengeResponseBody(value: object): value is SubmitChallengeResponseBody {
    return true;
}

export function SubmitChallengeResponseBodyFromJSON(json: any): SubmitChallengeResponseBody {
    return SubmitChallengeResponseBodyFromJSONTyped(json, false);
}

export function SubmitChallengeResponseBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitChallengeResponseBody {
    if (json == null) {
        return json;
    }
    return {
        
        'newsletter': json['newsletter'] == null ? undefined : json['newsletter'],
        'zipCode': json['zipCode'] == null ? undefined : json['zipCode'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'milestoneId': json['milestoneId'] == null ? undefined : json['milestoneId'],
    };
}

export function SubmitChallengeResponseBodyToJSON(json: any): SubmitChallengeResponseBody {
    return SubmitChallengeResponseBodyToJSONTyped(json, false);
}

export function SubmitChallengeResponseBodyToJSONTyped(value?: SubmitChallengeResponseBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'newsletter': value['newsletter'],
        'zipCode': value['zipCode'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'milestoneId': value['milestoneId'],
    };
}

